module.exports = __webpack_public_path__ + "static/media/icon-menu.2b78202e.svg";